import React from 'react';
import styled from 'styled-components';
import MaterialAliasColumnInfo from './component/materialAliases/MaterialAliasColumnInfo';
import MaterialAliasList from './component/materialAliases/MaterialAliasList';
import MaterialAliasMetaStation from './component/materialAliases/MaterialAliasMetaStation';
import PageAboutMaterialAlias from './component/materialAliases/PageAboutMaterialAlias';

const AdminMaterialAliases: React.FC = () => (
  <MaterialAliasContainer>
    <MaterialAliasMetaStation />
    <MaterialAliasColumnInfo />
    <MaterialAliasList />
    <PageAboutMaterialAlias />
  </MaterialAliasContainer>
);

const MaterialAliasContainer = styled.main`
  width: 96%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin-bottom: 3vh;
  overflow: hidden;
`;

export default AdminMaterialAliases;
